import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Úspěšně přihlášen');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Chyba při přihlášení');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 via-emerald-50 to-cyan-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="flex justify-center mb-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-cyan-500 to-emerald-500 flex items-center justify-center">
                <CheckCircle2 className="h-7 w-7 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-cyan-900 leading-tight">Kvalita Zdravé</h1>
                <h1 className="text-xl font-bold text-emerald-700 leading-tight">Stravování</h1>
              </div>
            </div>
          </div>

          <h2 className="text-xl font-semibold text-slate-900 mb-6 text-center">Přihlášení</h2>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="email-input"
                placeholder="vas@email.cz"
              />
            </div>

            <div>
              <Label htmlFor="password">Heslo</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="password-input"
                placeholder="••••••••"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-gradient-to-r from-cyan-500 to-emerald-500 hover:from-cyan-600 hover:to-emerald-600"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? 'Přihlašování...' : 'Přihlásit se'}
            </Button>
          </form>

          <p className="mt-6 text-center text-sm text-slate-600">
            Nemáte účet?{' '}
            <Link to="/register" className="text-cyan-600 font-medium hover:underline">
              Zaregistrovat se
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};